import { Observable } from 'rxjs';
import { BaseField } from '../base-field';

export class SelectField<T = any> extends BaseField<T> {
  public values?: SelectFieldItem[];
  public useAsync?: boolean;
  public valuesAsync?: Observable<SelectFieldItem[]>;
  public multiple?: boolean = false;
  public onValueSelectedFunc?: (value: any) => void;
  public useValueSelected?: boolean;
  public valueSelected?: Observable<SelectFieldItem>;
  public tooltip?: boolean;
  public labelTooltip?: string;
  public tooltipText?: string;
  public esconderFiltro?: boolean;


  constructor(init: Partial<SelectField<T>>) {
    super('Select', init);
    this.multiple = init.multiple ?? false;

    if (!init.css) {
      this.css = 'col-4';
    }
  }
}
export interface SelectFieldItem {
  value: string;
  text: string;
  id: string;
}
